import { Text, HStack } from '@chakra-ui/react'
import { faBadgeCheck } from '@fortawesome/pro-regular-svg-icons'

import Icon from 'src/components/widgets/Icon/Icon'
import { BrandColor } from 'src/types'

export const Exclusivity: React.FC<{
  brandColor: BrandColor
  isExclusive: boolean
}> = ({ brandColor, isExclusive }) =>
  isExclusive ? (
    <HStack className="input-label" color={brandColor}>
      <Icon icon={faBadgeCheck} />
      <Text data-testid="itemCard-onlyOntItList">Only on ItList!</Text>
    </HStack>
  ) : null

export default Exclusivity
